import React from 'react';
import { Modal, Button, Form, Alert, Row, Col } from 'react-bootstrap';

function VerificationModal(props) {
  const {
    isLoading,
    step,
    request,
    attachment,
    mimeType,
    filename,
    accept,
    decline,
    changeStep,
    changeSelect,
    error,
    showModal,
    handleClose,
    handleShow,
    country,
    declineReason,
    setCustomReason,
    validated
  } = props;

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Prüfen
      </Button>

      <Modal show={showModal} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Zulassungsdokument: {filename}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {attachment &&
            (mimeType === 'application/pdf' ? (
              <embed
                className="preview-image-pdf"
                src={attachment}
                type="application/pdf"
              ></embed>
            ) : (
              <img
                className="preview-image"
                alt="Fahrzeugschein Upload"
                src={attachment}
              />
            ))}

          {step === 1 ? (
            <div className="modal__container">
              <div className="modal__desc-container">
                <h6>Zu überprüfende Daten</h6>
                <p>VIN: {request.vin}</p>
              </div>

              <div className="modal__button-container">
                <Button
                  variant="outline-dark"
                  className="modal__button"
                  disabled={isLoading}
                  onClick={!isLoading ? () => accept(request.id) : null}
                >
                  {isLoading ? 'Warten…' : 'Fahrzeugschein akzeptieren'}
                </Button>
                <Button
                  variant="outline-dark"
                  className="modal__button"
                  onClick={() => changeStep(2)}
                >
                  {'Fahrzeugschein ablehnen'}
                </Button>
              </div>
            </div>
          ) : (
            <>
              {error && error.length && <Alert variant="danger">{error}</Alert>}
              <div className="modal__container">
                <div className="modal__desc-container">
                  <Form noValidate validated={validated}>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12">
                    <Form.Label>Ablehnungsgrund auswählen</Form.Label>
                      <Form.Control as="select" onChange={changeSelect} defaultValue={""} required>
                        <option disabled={true} value="">Option wählen</option>
                        {/* <option value="none">Ablehnungsgrund auswählen</option> */}
                        <option value="vin_mismatch">
                          VIN stimmt nicht überein
                        </option>
                        <option value="excessive_redaction">
                          Zu stark geschwärzt
                        </option>
                        <option value="image_quality">
                          Bildqualität zu schlecht
                        </option>
                        <option value="incorrect_document">
                          Falsches Dokument (Kein Fahrzeugschein)
                        </option>
                        <option value="verification_problem">
                          Verdacht auf Fälschung
                        </option>
                        <option value="andere">
                          Andere
                        </option>
                      </Form.Control>
                    </Form.Group>
                  </Row>
                  {
                    step === 3 &&
                    <Row className="mb-3">
                    <Form.Group as={Col} md="12" controlId="customReason">
                      <Form.Label>Grund hinzufügen</Form.Label>
                      <Form.Control
                            required={true}
                            as="textarea" 
                            aria-label="With textarea" 
                            value={declineReason} 
                            onChange={setCustomReason} 
                      />
                      <Form.Text id="customReasonCount" muted>
                      {declineReason.length} / 100
                      </Form.Text>
                    </Form.Group>
                    </Row>
                  }
                  </Form>
                </div>

                <div className="modal__button-container modal__button-container--align-left">
                  <Button
                    variant="outline-dark"
                    className="modal__button modal__button--align-left"
                    disabled={!validated}
                    onClick={!isLoading ? () => decline(request.id) : null}
                  >
                    {isLoading ? 'Warten…' : 'Fahrzeugschein ablehnen'}
                  </Button>
                  <Button variant="link" onClick={() => changeStep(1)}>
                    Zurück
                  </Button>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default VerificationModal;
